//react imports
import React, {useState, useRef} from 'react'
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation, useNavigate } from 'react-router-dom';

//mui imports
import { Box, Button, Paper, responsiveFontSizes } from '@mui/material';
//external imports

//internal imports
import { getConfigurl } from "../../Config/config";
import { loginRequest, protectedResources } from "../../authConfig"
import SelectForm from '../Select/SelectForm';
import { fetchDeafultView, fetchViewConfig, fetchViews, fetchData, fetchAvailableSkids } from '../../Helper/Fetch/fetch';
import {useConfig, useConfigDispatch} from '../ViewConfig/ConfigProvider'
import { configBuilder } from '../ViewConfig/ConfigBuilder';
import { useSkidConfig, useSkidConfigDispatch } from '../AvailableSkids/SkidsProvider'
import {useTracker, useTrackerDispatch} from '../FetchTracker/FetchTrackerProvider'
import {useSkidsWithConfig, useSkidsWithConfigDispatch, Skid} from '../AvailableSkids/skidsWithConfigProvider'
import DateForm from '../Select/DateForm';
import validateHistoricFetch from './validateHistoricFetch';
import { fetchAvailableSkidsWithConfig } from '../../Helper/Fetch/fetch';
import { isPopulated, toSelectOptions, mapToSelectOptions } from '../AvailableSkids/skidsHelpers';
import {getTZoffesetFromTZ} from '../../Helper/timeHelpers';



//Type Definitons
interface SelectorProps{
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    dataHandler: ResponseHandler,
    setSkid: React.Dispatch<React.SetStateAction<string>>,
    skid:string
    setStart: React.Dispatch<React.SetStateAction<number>>,
    start:number
    setEnd: React.Dispatch<React.SetStateAction<number>>,
    end:number
    setMessage:React.Dispatch<React.SetStateAction<string>>,
    setTimezone: React.Dispatch<React.SetStateAction<string>>,
    timezone:string,
    skids:Set<string>,
    skidsWithConfig:Map<string,Skid>
}
export interface ResponseHandler{
    (resp:Promise<Response>): void
}
export interface HandlerFunc{
    (event:React.ChangeEvent<HTMLInputElement>): void
}
interface LocationState{
    targetSkid: string
}
//Helper functions
function getAggregateOptions(start:number, end:number):number[]{
    const delta = end-start
    const day = 8640
    const minute = 60
    const hour = 3600
    if (delta >= day) {
        return [5*minute, 30*minute, hour, 2*hour]
    }
    return [5,30,minute, 5*minute]
}

//Start of component
function HistoricSelector(props:SelectorProps){
//constants
    const { setLoading, dataHandler, setSkid, skid, start, setStart, end, setEnd, setMessage, timezone, setTimezone,} = props
    const { instance, accounts, inProgress } = useMsal();
    const locationState = useLocation().state as LocationState;
        var targetSkid = locationState?.targetSkid
     const skids = useSkidConfig()
    const SkidDispatch = useSkidConfigDispatch()
    const skidsWithConfig= useSkidsWithConfig()
    const skidsWithConfigDispatch = useSkidsWithConfigDispatch()
    const Tracker = useTracker()
    const TrackerDispatch = useTrackerDispatch()
    const [viewsFetched, setViewsFetched] = useState(false)
    const viewsFetchedRef = useRef(false)
    const viewConfig = useConfig();
    const viewConfigDispatch =useConfigDispatch();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const [skidViews, setSkidViews] = useState(['']);
    const [aggregation,setAggregation] = useState(300)
    const [availableTimezones, setAvailableTimezones] = useState(new Set(["UTC",Intl.DateTimeFormat().resolvedOptions().timeZone,"Europe/Oslo","Europe/London","America/Guyana","Africa/lagos","Asia/Dubai","Asia/singapore","Australia/Perth","America/New_York","America/Los_Angeles","America/Houston"]))
    const aggeregateOptionText = (option:number)=>{
        if (option>3600){
            const text = `${option/3600} Hours`
            return text
        }else if(option===3600){
            const text = `${option/3600} Hour`
            return text
        }else if (option>60){
            const text = `${option/60} Min`
            return text
        }else{
            const text = `${option} Sec`
            return text
        }
    }
    
    
//Handlers 
    function StartSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        console.log("start time selected:",event.target.value, typeof(event.target.value))
        const date = new Date(event.target.value)
        const clientOffset = date.getTimezoneOffset()*60*1000*-1
        console.log("client ofsett is:",clientOffset)
        console.log("Converted start time:",date.getTime(),date.toUTCString())
        setStart(date.getTime()+clientOffset)
        
    }
    function EndSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        console.log("end time selected:",event.target.value,typeof(event.target.value))
        const date = new Date(event.target.value)
        const clientOffset = date.getTimezoneOffset()*60*1000*-1
        console.log("client ofsett is:",clientOffset)
        console.log("Converted end time:",date.getTime(),date.toUTCString())
        setEnd(date.getTime()+clientOffset)
    }
    function TimezoneSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        console.log("Selected timezone:",event.target.value)
        setTimezone(event.target.value)
    }

    function ConfigSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        fetchViewConfig(request,instance,skid,event.target.value).then(res => res.json()).then((items) =>{
            viewConfigDispatch({
                type:'updateConfig',
                chart: null,
                category: null,
                config: configBuilder(items),
            })
        })
    }

    function SkidSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        const skidName = skidsWithConfig.get(event.target.value).name
        
        fetchDeafultView(request,instance,skidName).then(res => res.json()).then((items) =>{
            viewConfigDispatch({
                type:'updateConfig',
                chart: null,
                category: null,
                config: configBuilder(items),
              })
        })
       fetchViews(request,instance,skidName).then(res => res.json()).then((items)=>{
            setSkidViews(items.Views)
       })
       const skidTZ = skidsWithConfig.get(event.target.value).timezone
       if (skidTZ){
        setTimezone(skidTZ)
       }
       setSkid(event.target.value)
    }
    function AggregationSelectHandler(event:React.ChangeEvent<HTMLInputElement>){
        setAggregation(parseInt(event.target.value))
    }
    function fetchHandler(){
        const tz = getTZoffesetFromTZ(timezone)*1000
        console.log('Timezone offset (ms):',tz)
        const options = {start: start-tz, end: end-tz, skid: skidsWithConfig.get(skid).name, view: viewConfig.charts, aggregation:aggregation}
        const msg = validateHistoricFetch(options)
        if (msg==='ok'){
            setLoading(true)
            let resp = fetchData(request, instance, options)
            dataHandler(resp)
        }else{
            setMessage(msg)
        }
    }
    
 /*    //Checks for refetch condition, 0 skids and no previous fetch
    console.log('Avilable skids:',skids)
    console.log('Skids fetched tracker:',Tracker.skid)
        if (isPopulated(skids)=== false && Tracker.skid === false){ 
            console.log('No Skids Available, and no previous fetch, starting refetch')
            if (inProgress ===InteractionStatus.None ){
                fetchAvailableSkids(request, instance).then((res => res.json())).then((items)=>{
                    SkidDispatch({type:'addSkids',skids:items.skids})
                    TrackerDispatch({type:'skid',value:true})
                })
            }    
        }
    console.log('Available skids with config:',skidsWithConfig)
    console.log('Skids with config fetched tracker:',Tracker.skidsWithConfig)
    if(isPopulated(skidsWithConfig)===false && Tracker.skidsWithConfig===false){
        console.log('No Skids Available with config, and no previous fetch, starting refetch')
        if (inProgress ===InteractionStatus.None ){
            fetchAvailableSkidsWithConfig(request, instance).
            then((res => res.json()))
            .then((items)=>{
                const skidConfigMap = new Map<string, {name:string, timezone:string}>()
                console.log("raw:",items.skids)
                items.skids.forEach((skid:{name:string, timezone:string, displayName:string,id:string, operational:string, dualName:string, dualDisplayName:string})=>{
                    console.log(skid)
                    skidConfigMap.set(skid.name,{name:skid.name, timezone:skid.timezone})
                })
                console.log("dispatching:",skidConfigMap)
                skidsWithConfigDispatch({type:'addSkidsWithConfig',skids:skidConfigMap})
                TrackerDispatch({type:'skidsWithConfig',value:true})
            })

            //fetch here
            
            //dispatch tracker here
            //dispatch skids here
        }

    } */
console.log("location state:",locationState)
console.log("skid:",skid)
console.log("skidviews:",skidViews)
if (locationState != undefined && skidViews[0]=='' && !viewsFetchedRef.current && skid && isPopulated(skidsWithConfig)){
    console.log("Fetching views")
    //setViewsFetched(true)
    viewsFetchedRef.current = true
    fetchDeafultView(request,instance,skidsWithConfig.get(skid).name).then(res => res.json()).then((items) =>{
            viewConfigDispatch({
                type:'updateConfig',
                chart: null,
                category: null,
                config: configBuilder(items),
              })
        })
       fetchViews(request,instance,skidsWithConfig.get(skid).name).then(res => res.json()).then((items)=>{
            setSkidViews(items.Views)
       })
    console.log("views fetched")
}
return(
    <Paper className='Selector-Paper' key='Selector' elevation={8} sx={{backgroundColor:'#273746', width: '100%', py:'15px'}} >
       <Box sx={{width:'100%' , display: 'flex',  flexDirection:{ xs:'column',md:'row'}, justifyContent:{xs:'space-between',md:'flex-start'}, alignItems: {xs:'auto',md:'flex-start'}, p: '10px'}}>
            {isPopulated(skidsWithConfig) &&
                <SelectForm title='Skid' options={mapToSelectOptions(skidsWithConfig)} selected={skid} changeHandler={SkidSelectHandler} />
            }
            <SelectForm title='View' options={skidViews} selected={viewConfig.name} changeHandler={ConfigSelectHandler} />
            <DateForm title='Time' startHandler={StartSelectHandler} endHandler={EndSelectHandler} startValue={start} endValue={end} timezone={timezone} />
            <SelectForm title='Timezone' options={toSelectOptions(availableTimezones)} selected={timezone} changeHandler={TimezoneSelectHandler}/>
            <SelectForm title='Aggregation' options={getAggregateOptions(start,end)} selected = {aggregation} changeHandler={AggregationSelectHandler} optionDisplay={aggeregateOptionText} />
            <Button variant="contained" color="success" onClick={fetchHandler}>Get Data</Button> 
        </Box>
    </Paper>
    )
}

export default HistoricSelector